// Met welk tabblad een wervingsactie opent.
//
// Nodig omdat elke actie op 'Overzicht' opende. Bij een nieuwe actie staat daar
// alleen twee keer "Nog geen registraties.", en het gebied kies je op een
// ander tabblad waar niets naar wijst. Zutphen Energie liep zo vast: hun actie
// bleef zonder stad en wijk. Zolang er geen wijk gekozen is, begint het werk op
// 'Gebied'.
//
// AI-CONTEXT: See docs/features/wervingsacties-registratie.md

/**
 * @param {{ Wijken?: Array<object> }} campaign - Het Wervingsacties-document
 * @returns {'scope' | 'overzicht'} Id van het tabblad in Detail.jsx
 */
const defaultCampaignView = (campaign) =>
    Array.isArray(campaign?.Wijken) && campaign.Wijken.length > 0 ? 'overzicht' : 'scope'

export { defaultCampaignView }
